import type { ToneOverlay } from "../index.js";

// The nonna voice: a warm worried grandmother — food, family, endearments. Like dark,
// it's a "lighten the mood" voice, so its lines rotate every other hour (TONE_ROTATE_MS).
// Each variant must keep the base {placeholders} (enforced by tone-guardrail.test.ts).
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} near you, cuore — pay attention now",
    "{hazard} close by, tesoro. Eyes up.",
    "{hazard} nearby — I don't like it. Watch out.",
    "{hazard} near you. Please, be careful now.",
    "{hazard} close. Stay near me, eh?",
  ],
  "alert.toast.escalation": [
    "The {hazard} is getting worse, please don't wait",
    "The {hazard} grows, caro — move now",
    "{hazard} worse now. Don't be stubborn, go.",
    "{hazard} is spreading. Madonna. Hurry.",
  ],
  "alert.toast.inPath": [
    "{hazard} is coming your way — move, sì?",
    "{hazard} heading to you, tesoro — go, go",
    "{hazard} comes for you. Up, up, move!",
    "{hazard} almost at your door — leave now, please",
  ],
  "alert.toast.allClear": [
    "All calm near {place} now, grazie a Dio",
    "{place} is quiet again. Sit, breathe.",
    "Safe near {place}, cuore. I was worried.",
    "All good near {place}. Now drink some water.",
  ],
  "alert.toast.tap": [
    "Come, tap here — I'll tell you what to do",
    "Tap, tesoro — I'll walk you through it",
    "Tap here. Nonna has a plan.",
  ],
  "alert.takeover.title": [
    "{hazard} — andiamo, move now, don't argue",
    "{hazard} — up, up! Go, I mean it",
    "{hazard} — basta talking, move, caro",
  ],
  "alert.takeover.details": "Show me everything",
  "alert.takeover.dismiss": "Okay, okay",
  "now.status.allClear": [
    "All calm, tesoro.",
    "Quiet now, caro.",
    "Everything's fine — sit, relax.",
    "All good. Did you eat?",
    "Calm, grazie a Dio.",
    "Nice and quiet. Rest a little.",
    "Peaceful now, cuore.",
  ],
  "now.status.stayAware": [
    "Stay sharp, eh?",
    "Keep your eyes open, tesoro.",
    "Pay attention, for me.",
    "Watch out a little, sì?",
    "Stay close, caro.",
  ],
  "now.status.sub.allClear": [
    "Nothing near you right now. Drink some water.",
    "All quiet. Did you eat something?",
    "Nothing in your radius. Good. Sit a moment.",
    "Clear for now, tesoro. Breathe.",
    "Nothing close. Put on a sweater anyway.",
  ],
  "now.activity.empty": [
    "Quiet for now. Did you eat?",
    "Nothing happening. Good. Rest a little.",
    "All calm. Call your mother, eh?",
    "Nothing here, cuore. Have some soup.",
    "Empty and quiet. Enjoy it, tesoro.",
  ],
  "onboarding.promise.tagline": "Neighbors looking after neighbors, like family.",
  "onboarding.promise.continue": "Come in, come in",
  "onboarding.home.browse": "Just looking, for now",
  "you.voice.intro": "Tell me how you like to be spoken to, caro.",
};
